import { render, staticRenderFns } from "./DataInputs.vue?vue&type=template&id=423627b2&scoped=true&"
import script from "./DataInputs.vue?vue&type=script&lang=js&"
export * from "./DataInputs.vue?vue&type=script&lang=js&"
import style0 from "./DataInputs.vue?vue&type=style&index=0&id=423627b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423627b2",
  null
  
)

export default component.exports